import React from 'react'
import InfiniteScroller from 'react-infinite-scroller'
import { isEmpty, map } from 'lodash'

import Media from '~/components/media'
import Loader from '~/truck/loader'
import theme from '~/truck/theme'
import { ratingColor } from '~/utils/constants'

import EmptyState from '../../components/empty-state'
import Overview from '../../components/overview'
import ProductReview from '../../components/product-review'

import { ContentContainer, ProductReviewsHeader } from './ProductReviews.style'

interface ProductReviewsViewProps {
  reviewButtonContent: {
    buttonAction: string
    label: string
    onClick: () => void
  }
  imageUrl: string
  reviewStats: {
    rating: number
    numOfReviews: number
    oneStar: number
    twoStars: number
    threeStars: number
    fourStars: number
    fiveStars: number
  }
  pageInfo: {
    total: number
    page: number
    hasPrevPage: boolean
    hasNextPage: boolean
    pages: number
  }
  loadMore: (page: number) => Promise<any>
  productReviews: any[]
}

const ProductReviewsView = (props: ProductReviewsViewProps) => {
  const { reviewButtonContent, imageUrl, reviewStats, pageInfo, loadMore, productReviews } = props

  return (
    <ContentContainer style={{ marginTop: theme.spacing.comfortable }}>
      <ProductReviewsHeader>
        <h4 className="text-xl font-semibold">Reseñas del producto</h4>
        {!isEmpty(productReviews) && (
          <Media
            desktop={
              <span className="font-semibold text-brand-secondary" onClick={reviewButtonContent.onClick}>
                {reviewButtonContent.buttonAction}
              </span>
            }
          />
        )}
      </ProductReviewsHeader>
      {isEmpty(productReviews) && (
        <EmptyState
          imageUrl={imageUrl}
          buttonAction={reviewButtonContent.buttonAction}
          label={reviewButtonContent.label}
          onClick={reviewButtonContent.onClick}
        />
      )}
      {!isEmpty(productReviews) && !isEmpty(reviewStats) && (
        <>
          <Overview
            color={ratingColor}
            reviewStats={reviewStats}
            mobileData={{
              productReviews,
              onClick: reviewButtonContent.onClick,
              buttonAction: reviewButtonContent.buttonAction,
            }}
          />
          <InfiniteScroller
            loader={<Loader key={0} centered />}
            pageStart={1}
            hasMore={pageInfo.hasNextPage}
            initialLoad
            loadMore={loadMore}
          >
            {map(productReviews, review => (
              <ProductReview key={review.id} {...review} />
            ))}
          </InfiniteScroller>
        </>
      )}
    </ContentContainer>
  )
}

export default ProductReviewsView
